/**
 * Wait for an element before resolving a promise
 * @param {String} querySelector - Selector of element to wait for
 * @param {Integer} timeout - Milliseconds to wait before timing out, or 0 for no timeout
 */

function waitForElement(querySelector, timeout) {
  return new Promise((resolve, reject) => {
    var timer = false;
    if (document.querySelector(querySelector)) return resolve();
    const observer = new MutationObserver(() => {
      if (document.querySelector(querySelector)) {
        observer.disconnect();
        if (timer !== false) clearTimeout(timer);
        return resolve();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    if (timeout)
      timer = setTimeout(() => {
        observer.disconnect();
        reject();
      }, timeout);
  });
}

function moveTheButtons() {
  const form = document.querySelector(".ajax-product-form");
  const widget = document.querySelector(".sealsubs-target-element");
  const paymentButtonsContainer = form.querySelector(".payment-buttons");
  const sellingPlansContainer = form.querySelector(
    ".selling-plan-description"
  );
  const oneTimePurchaseDescription =
    sellingPlansContainer?.querySelector(".one-time-purchase");

  const widgetSubscribeButton = paymentButtonsContainer?.querySelector(
    ".sealsubs-subscribe-now"
  );
  const themeSubscribeButton =
    paymentButtonsContainer?.querySelector(".btn--subscribe");

  const subscribeButton = widgetSubscribeButton
    ? widgetSubscribeButton
    : themeSubscribeButton;
  const addToCartButton = paymentButtonsContainer?.querySelector(".btn--atc");
  const widgetOptions = widget.querySelectorAll(".sls-option-container");

  widgetOptions.forEach((option) => {
    const optionContentContainer = option.querySelector(
      ".sls-label-container"
    );

    if (option.hasAttribute("data-selling-plan-group-id")) {
      optionContentContainer.insertAdjacentElement(
        "beforeend",
        subscribeButton
      );
    } else {
      optionContentContainer.insertAdjacentElement(
        "beforeend",
        oneTimePurchaseDescription
      );

      optionContentContainer.insertAdjacentElement(
        "beforeend",
        addToCartButton
      );
    }
  });
}



// function insertActionButtonsToWidget() {
//   const productForm = document.querySelector(".ajax-product-form");

//   if (!productForm) {
//     return;
//   }

//   console.log("ajax-product-form exist");

//   const observer = new MutationObserver(function (mutations_list) {
//     mutations_list.forEach(function (mutation) {
//       mutation.addedNodes.forEach(function (added_node) {
//         console.log(added_node);
//         if (added_node.classList.contains("sealsubs-target-element")) {
//           moveTheButtons(added_node, productForm);
//         }
//       });
//     });
//   });

//   function moveTheButtons(widget, form) {
//     const paymentButtonsContainer = form.querySelector(".payment-buttons");
//     const sellingPlansContainer = form.querySelector(
//       ".selling-plan-description"
//     );
//     const oneTimePurchaseDescription =
//       sellingPlansContainer?.querySelector(".one-time-purchase");

//     const widgetSubscribeButton = paymentButtonsContainer?.querySelector(
//       ".sealsubs-subscribe-now"
//     );
//     const themeSubscribeButton =
//       paymentButtonsContainer?.querySelector(".btn--subscribe");

//     const subscribeButton = widgetSubscribeButton
//       ? widgetSubscribeButton
//       : themeSubscribeButton;
//     const addToCartButton = paymentButtonsContainer?.querySelector(".btn--atc");
//     const widgetOptions = widget.querySelectorAll(".sls-option-container");

//     widgetOptions.forEach((option) => {
//       const optionContentContainer = option.querySelector(
//         ".sls-label-container"
//       );

//       if (option.hasAttribute("data-selling-plan-group-id")) {
//         optionContentContainer.insertAdjacentElement(
//           "beforeend",
//           subscribeButton
//         );
//       } else {
//         optionContentContainer.insertAdjacentElement(
//           "beforeend",
//           oneTimePurchaseDescription
//         );

//         optionContentContainer.insertAdjacentElement(
//           "beforeend",
//           addToCartButton
//         );
//       }
//     });
//   }

//   function createAndInsert(button, contentContainer) {
//     const newDiv = document.createElement("div");
//     newDiv.classList.add("sls-selling-plan-group-options");
//     newDiv.insertAdjacentElement("beforeend", button);

//     contentContainer.insertAdjacentElement("beforeend", newDiv);
//   }

//   observer.observe(productForm, { subtree: false, childList: true });
// }

document.addEventListener("DOMContentLoaded", () => {
  waitForElement(".sealsubs-target-element", 3000)
  .then(function () {
    moveTheButtons();
    console.log('Buttons moved');
  })
  .catch(() => {
    console.log('Buttons not moved');
  });
});
